import Header from '../components/Header'
import Footer from '../components/Footer'
import Head from '../components/Head'
import * as common from "../common/commonFunction"
import { useRouter } from 'next/router'
import axios from 'axios'
import { useState, useEffect } from 'react';

const findPw = () => {

    const router = useRouter()
    const [placeholder,setPlaceHolder] = useState('이메일을 입력해 주세요.');

    if (!router.isReady) return;


    const params = router.query;

    console.log(params)

    if (params.token && params.token != '') {
        setPlaceHolder('비밀번호를 입력해 주세요.')
    }

    return (
        <>
            <Head />
            <link rel="stylesheet" href="/css/findPw.css" />
            <Header />
            <div className="container" onClick={()=>common.focusOutMenu()}>
                <content>
                    <div className="input-form">
                        <div className="row">
                            <div className="title_bar"><hr /></div>
                            <div className="title_bar"> <h4 className="text-center fs-2">Find Password</h4></div>
                            <div className="title_bar"><hr /></div>
                        </div>
                        <p className="text-center">Enter the Email that you want to find your password.</p>

                        <form className="login-form" id="find-password">
                            <div className="mb-3">
                                <input type="text" name="email" className="form-control box" id="userEmail" placeholder={placeholder} required/>
                            </div>
                            <button className="w-100 btn btn-lg basicBtn" type="button" onClick={()=>common.findPassword()}>Reset Password</button>
                        </form>

                        <button className="login-btn w-100 btn btn-primary btn-lg basicBtn mt-5 mb-3" id="loginBtn" type="button" onClick={() => common.moveToLink('/login')}>로그인</button>
                    </div>
                </content>
            </div >
            <Footer />
        </>
    )
}

export default findPw;